import React from 'react';
import { Star, CheckCircle } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    text: 'Lo descargué un martes a la noche y esa misma noche hice la cena. Nunca había cocinado bien en mi vida.',
    name: 'Valentina M., Buenos Aires',
    initials: 'VM'
  }, {
    text: 'En serio no sabía ni hervir agua. Ahora uso la air fryer todos los días. Las recetas son re fáciles.',
    name: 'Sofía R., Córdoba',
    initials: 'SR'
  }, {
    text: 'Lo compré con dudas y al instante lo recuperé. Ya no pido delivery. Mi familia me pregunta qué hice de diferente.',
    name: 'Luciana P., Rosario',
    initials: 'LP'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-170">
      <div className="max-w-6xl mx-auto" data-id="element-171">
        <p className="text-center text-brand-mediumGray text-sm font-medium mb-3" data-id="element-172">
          Más de 200 dueñas de air fryer ya lo tienen
        </p>

        <div className="flex justify-center items-center gap-1 mb-8" data-id="element-173">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-yellow text-brand-yellow" data-id="element-174" />)}
          <span className="ml-2 text-brand-mediumGray font-semibold" data-id="element-175">
            4.9/5 promedio
          </span>
        </div>

        <div className="flex gap-6 overflow-x-auto snap-x pb-4 md:grid md:grid-cols-3 md:overflow-visible" data-id="element-176">
          {testimonials.map((t, i) => <div key={i} className="min-w-[85%] sm:min-w-[70%] md:min-w-0 snap-center bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col" data-id="element-177">
              <p className="text-brand-darkGray font-medium italic mb-6 flex-grow leading-relaxed" data-id="element-178">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-179">
                <div className="w-12 h-12 bg-brand-purple text-white rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0" data-id="element-180">
                  {t.initials}
                </div>
                <div data-id="element-181">
                  <p className="font-semibold text-brand-darkGray text-sm" data-id="element-182">
                    {t.name}
                  </p>
                  <p className="text-xs text-green-600 flex items-center gap-1 font-medium mt-0.5" data-id="element-183">
                    <CheckCircle className="w-3.5 h-3.5" data-id="element-184" /> Compradora
                    verificada
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}